"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "arezzo": {
    "0e799115": [{
      "hkey": "9f420ba7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "9f420ba7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "93e63f90": [{
      "hkey": "0d2638b4",
      "slug": "cappuccini-villa-severi",
      "name": "Cappuccini-Villa Severi",
      "primary": true,
      "skipSearch": false
    }],
    "fonterosa-pantano": [{
      "hkey": "0d2638b4",
      "slug": "cappuccini-villa-severi",
      "name": "Cappuccini-Villa Severi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "arezzo"
    }],
    "0195c129": [{
      "hkey": "9f420ba7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "guido-monaco": [{
      "hkey": "9f420ba7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "arezzo"
    }],
    "0595c9c1": [{
      "hkey": "c44d2c52",
      "slug": "la-pace-staggiano",
      "name": "La Pace-Staggiano",
      "primary": true,
      "skipSearch": false
    }],
    "la-pace-la-marchionna": [{
      "hkey": "c44d2c52",
      "slug": "la-pace-staggiano",
      "name": "La Pace-Staggiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b6a1b400": [{
      "hkey": "7d82237c",
      "slug": "bagnoro-santa-firmina",
      "name": "Bagnoro-Santa Firmina",
      "primary": true,
      "skipSearch": false
    }],
    "le-pietre": [{
      "hkey": "7d82237c",
      "slug": "bagnoro-santa-firmina",
      "name": "Bagnoro-Santa Firmina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "arezzo"
    }],
    "316cd81b": [{
      "hkey": "4dd78be9",
      "slug": "meridiana-pescaiola",
      "name": "Meridiana-Pescaiola",
      "primary": true,
      "skipSearch": false
    }],
    "meridiana": [{
      "hkey": "4dd78be9",
      "slug": "meridiana-pescaiola",
      "name": "Meridiana-Pescaiola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "85daf42f": [{
      "hkey": "4dd78be9",
      "slug": "meridiana-pescaiola",
      "name": "Meridiana-Pescaiola",
      "primary": true,
      "skipSearch": false
    }],
    "pescaiola": [{
      "hkey": "4dd78be9",
      "slug": "meridiana-pescaiola",
      "name": "Meridiana-Pescaiola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "arezzo"
    }],
    "28b5a0c3": [{
      "hkey": "345e828f",
      "slug": "frassineto-policiano-rigutino",
      "name": "Frassineto-Policiano-Rigutino",
      "primary": true,
      "skipSearch": false
    }],
    "rigutino": [{
      "hkey": "345e828f",
      "slug": "frassineto-policiano-rigutino",
      "name": "Frassineto-Policiano-Rigutino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "01817a91": [{
      "hkey": "9f420ba7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-clemente": [{
      "hkey": "9f420ba7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "arezzo"
    }],
    "610fd463": [{
      "hkey": "1ee955e0",
      "slug": "san-leo-via-fiorentina",
      "name": "San Leo-Via Fiorentina",
      "primary": true,
      "skipSearch": false
    }],
    "san-leo": [{
      "hkey": "1ee955e0",
      "slug": "san-leo-via-fiorentina",
      "name": "San Leo-Via Fiorentina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e1f75ce4": [{
      "hkey": "7d82237c",
      "slug": "bagnoro-santa-firmina",
      "name": "Bagnoro-Santa Firmina",
      "primary": true,
      "skipSearch": false
    }],
    "santa-firmina-bagnoro": [{
      "hkey": "7d82237c",
      "slug": "bagnoro-santa-firmina",
      "name": "Bagnoro-Santa Firmina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "17457a91": [{
      "hkey": "89bd23e3",
      "slug": "saione-via-vittorio-veneto",
      "name": "Saione-Via Vittorio Veneto",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "ac120e81",
      "slug": "giotto-via-xxv-aprile",
      "name": "Giotto-Via XXV Aprile",
      "primary": true,
      "skipSearch": false
    }],
    "v-le-mecenate": [{
      "hkey": "ac120e81",
      "slug": "giotto-via-xxv-aprile",
      "name": "Giotto-Via XXV Aprile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "arezzo"
    }],
    "a4d21e8e": [{
      "hkey": "9f420ba7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "v-le-piero-della-francesca": [{
      "hkey": "9f420ba7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "arezzo"
    }],
    "13c2e0d2": [{
      "hkey": "9f420ba7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "via-roma-via-crispi": [{
      "hkey": "9f420ba7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "arezzo"
    }],
    "a90ed33a": [{
      "hkey": "89bd23e3",
      "slug": "saione-via-vittorio-veneto",
      "name": "Saione-Via Vittorio Veneto",
      "primary": true,
      "skipSearch": false
    }],
    "via-vittorio-veneto": [{
      "hkey": "89bd23e3",
      "slug": "saione-via-vittorio-veneto",
      "name": "Saione-Via Vittorio Veneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "04f252a2": [{
      "hkey": "ac120e81",
      "slug": "giotto-via-xxv-aprile",
      "name": "Giotto-Via XXV Aprile",
      "primary": true,
      "skipSearch": false
    }],
    "via-xxv-aprile": [{
      "hkey": "ac120e81",
      "slug": "giotto-via-xxv-aprile",
      "name": "Giotto-Via XXV Aprile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "arezzo"
    }],
    "d12fe462": [{
      "hkey": "ac120e81",
      "slug": "giotto-via-xxv-aprile",
      "name": "Giotto-Via XXV Aprile",
      "primary": true,
      "skipSearch": false
    }],
    "zona-giotto": [{
      "hkey": "ac120e81",
      "slug": "giotto-via-xxv-aprile",
      "name": "Giotto-Via XXV Aprile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7e7a7f2f": [{
      "hkey": "1ee955e0",
      "slug": "san-leo-via-fiorentina",
      "name": "San Leo-Via Fiorentina",
      "primary": true,
      "skipSearch": false
    }],
    "zona-via-fiorentina": [{
      "hkey": "1ee955e0",
      "slug": "san-leo-via-fiorentina",
      "name": "San Leo-Via Fiorentina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "arezzo"
    }],
    "d9331f9c": [{
      "hkey": "345e828f",
      "slug": "frassineto-policiano-rigutino",
      "name": "Frassineto-Policiano-Rigutino",
      "primary": true,
      "skipSearch": false
    }],
    "frassineto-puliciano-rigutino": [{
      "hkey": "345e828f",
      "slug": "frassineto-policiano-rigutino",
      "name": "Frassineto-Policiano-Rigutino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;